<template>
	<el-dialog title="Home Studio"
						 :visible.sync="$parent.dialog.location"
						 :width="modalWidth"
						 :close-on-click-modal="false"
						 :append-to-body="false">


		<div>
			<div class="row">
				<div class="col-lg-6 form-group">
					<div class="w-100">
						<el-select class="w-100 mb-2" :disabled="!canChangeLocation" clearable v-model="studioId" placeholder="Select a studio...">
							<el-option v-for="l in locations"
												 :key="l.id"
												 :label="l.title"
												 :value="l.id">
								<span style="color: #cc6600" class="float-left">{{l.title}}</span>
								<span class="float-right"><i>{{l.city}}</i></span>
							</el-option>
						</el-select>
						<el-alert type="info" :closable="false" v-if="!canChangeLocation">
							<p>
								You don't need to change your location because you already have access to all locations. If you'd like to change your plan, click view options below.
							</p>
							<el-button type="primary" @click.prevent="handleViewOptions" size="small" class="mb-3">View Options</el-button>


						</el-alert>
					</div>
					
				</div>
				<div class="col-lg-6" v-if="selectedStudio">
					<div v-html="selectedStudio.html"></div>
					<h5 v-html="selectedStudio.features"></h5>
				</div>
			</div>
			
			
			<!--app_UpdateADLocation @adsid @studioid-->
		</div>

		<el-alert :title="serverError" v-if="serverError"
							type="error"
							effect="dark"
							show-icon
							:closable="false" class="mt-4">
		</el-alert>



		<span slot="footer" class="dialog-footer">
			<el-button :disabled="thinking.save" @click="$parent.dialog.location = false">Cancel</el-button>
			<el-button :loading="thinking.save" type="primary" @click="submit" v-if="studioId !== originalStudioId && studioId !== '' && studioId !== null">Confirm</el-button>
		</span>
	</el-dialog>
	

</template>

<script>

	import { mapActions, mapGetters } from "vuex";
	import { rest } from "@/utilities/rest.js";
	export default {
		name: "membership-location",
		data() {

			return {

				originalStudioId: null,
				studioId: null,
				thinking: {
					save: false
				},
				serverError: null
			}
		},
		props: ["user"],
		created() {
			this.init();
			
		},
		computed: {
			...mapGetters({
				locations: "locations",
				payment: "payment",
				modalWidth: "modalWidth"
			}),

			canChangeLocation() {
				return this.payment.canChangeLocation;
			},

			selectedStudio() {
				return _.find(this.locations, ["id", this.studioId]);
			}
		},
		methods: {

			init() {
				this.serverError = null;
				if (this.payment.studioId) {
					this.studioId = this.payment.studioId;
				}
				this.originalStudioId = this.payment.studioId || null;
			},

			handleViewOptions() {
				let vm = this;
				this.$parent.dialog.location = false;
				setTimeout(() => {
					vm.$parent.dialog.plan = true;
				}, 500);
			},
			submit() {
				this.thinking.save = true;
				let payload = {
					userId: this.user.userId,
					studioId: this.studioId,
					productId: this.payment.productId
				};

				rest.post("Account", "/ChangeMembership", "json", JSON.stringify(payload)).then(response => {
					setTimeout(() => {
						this.$message.success("Changes have been saved.");
					}, 1000);
					this.$emit("fetch", "payment");
					this.$parent.dialog.location = false;
				}).fail((xhr) => {
					this.serverError = JSON.parse(xhr.responseText);
				}).always(() => {
					this.thinking.save = false;
				});
			}
		},

		watch: {
			'$parent.dialog.location': function (val) {
				this.init();
			}
		}
	}
</script>